import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    height: '20px',
    color:"#ffffff",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});

const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

const TOPICS = [
  {
    icon: '☀️',
    title: 'Light',
    body: 'Orchids love bright, indirect light. Direct sun can scorch leaves; too little prevents blooming. East-facing windows are ideal — south or west windows may need a sheer curtain to filter the light.',
    tip: 'Best spot: within 3–5 feet of a bright window where the sun doesn\'t shine directly on the plant.',
    mistake: 'A dark corner or a windowsill in a poorly lit room isn\'t enough for orchids to bloom reliably.',
  },
  {
    icon: '💧',
    title: 'Watering',
    body: 'Water thoroughly about once a week, then let the bark dry slightly before the next watering. Never let water sit in the crown (the center where leaves emerge) — it can cause rot.',
    tip: 'With Orchima™: fill the reservoir, let it soak 10–15 minutes, then open the valve and drain completely. Same routine every week.',
    mistake: 'Watering a little bit every day is the most common mistake. Orchids want a full soak followed by a dry-out period.',
  },
  {
    icon: '🌿',
    title: 'Fertilizer',
    body: '"Weakly, weekly" is the golden rule. Dilute orchid fertilizer to half strength and feed every 1–2 weeks during spring and summer. Cut back in winter when growth slows.',
    tip: 'Look for fertilizers labeled specifically for orchids — usually a balanced 20-20-20 formula. A little goes a long way.',
    mistake: 'Too much fertilizer burns roots. When in doubt, use half the recommended amount.',
  },
  {
    icon: '🌬️',
    title: 'Airflow & Humidity',
    body: 'Orchids thrive at 50–70% humidity. Central heating and AC dry indoor air significantly. A humidity tray — a shallow dish of pebbles and water under the pot — helps. Good airflow also prevents fungal problems.',
    tip: 'A small fan on a low setting running nearby is better than a still, stuffy room.',
    mistake: 'Misting leaves can encourage fungal spots. Focus on raising humidity at root level, not on the leaves.',
  },
  {
    icon: '🪴',
    title: 'Potting Medium & Repotting',
    body: 'Use orchid bark — never regular potting soil. Repot every 1–2 years when the bark breaks down, roots look crowded, or you notice a musty smell. Always repot after blooming, not during it.',
    tip: 'Soak fresh bark in water for 30–60 minutes before repotting. This pre-moistens it and helps it settle around the roots.',
    mistake: 'Sphagnum moss holds too much water and reduces airflow to roots. Stick with bark for most Phalaenopsis orchids.',
  },
  {
    icon: '🌡️',
    title: 'Temperature',
    body: 'Most orchids are comfortable at 65–80°F (18–27°C) during the day. A 10–15°F cooler night actually helps trigger blooming. Avoid cold drafts from windows or vents in winter.',
    tip: 'A cool windowsill in early fall is one of the best natural bloom triggers — temperature swings are your friend.',
    mistake: 'AC vents aimed directly at orchids cause cold stress and can kill developing flower spikes.',
  },
];

const BARK_STEPS = [
  'Wait until the orchid finishes blooming — spring or early summer is ideal.',
  'Gently remove the orchid from the pot and shake off old bark.',
  'Soak the roots briefly in lukewarm water and trim away any mushy or dead roots.',
  'Soak fresh orchid bark for 30–60 minutes to pre-moisten it.',
  'Set the orchid in the pot so the base of the lowest leaves sits just above the rim. Add bark gradually, tapping to settle.',
  'Water lightly. Resume your normal watering schedule after about one week.',
];


class OrchidEducation extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false
  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);

  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    updateUserProfileAction(null, this.props.loginData.accessToken);
  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    this.setState({ showOrderForm:!this.state.showOrderForm });
  };

  handleFirstNameChange(event) {
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
  }

  handleLastNameChange(event) {
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
  }

  handleEmailChange(event) {
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
  }

  handleCommentChange(event) {
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }

  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;

    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
            }
          }
        }
      }
    }

    return returnString;
  }

  handleAddress2Change(event) {
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }


  render() {
    return (
      <div style={{ backgroundColor: '#f9f9f7', minHeight: '100vh' }}>

        {/* Top nav */}
        <div style={{ backgroundColor: DARK, padding: '14px 24px' }}>
          <a href="/home" style={{ color: '#ffffff', textDecoration: 'none', fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>
            ← Back to Orchima Home
          </a>
        </div>

        {/* Hero */}
        <div style={{ backgroundColor: GREEN, padding: '56px 24px', textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#a8d5cf', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, marginTop: 0 }}>
            ORCHID CARE GUIDE
          </p>
          <h1 style={{ fontSize: 'clamp(24px, 5vw, 36px)', fontWeight: 700, color: '#ffffff', lineHeight: 1.3, margin: '0 auto 16px auto', maxWidth: 600 }}>
            Orchid Care Made Simple
          </h1>
          <p style={{ fontSize: 17, color: '#d0ede9', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
            You don't need to become an expert. Here are the six things that matter most — explained in plain language.
          </p>
        </div>

        {/* Topic cards */}
        <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px' }}>

          {TOPICS.map((topic, i) => (
            <div key={i} style={{ backgroundColor: '#ffffff', borderRadius: 10, padding: '28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
                <span style={{ fontSize: 28, marginRight: 12 }}>{topic.icon}</span>
                <h2 style={{ fontSize: 22, fontWeight: 700, color: DARK, margin: 0 }}>{topic.title}</h2>
              </div>
              <p style={{ fontSize: 16, color: GRAY, lineHeight: 1.8, marginBottom: 16, marginTop: 0 }}>{topic.body}</p>
              <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 8, padding: '12px 16px', marginBottom: 14 }}>
                <p style={{ fontSize: 13, fontWeight: 700, color: GREEN, margin: '0 0 4px 0', letterSpacing: 0.5, textTransform: 'uppercase' }}>Quick tip</p>
                <p style={{ fontSize: 15, color: '#333', margin: 0, lineHeight: 1.7 }}>{topic.tip}</p>
              </div>
              <div style={{ borderLeft: '3px solid #BF360C', paddingLeft: 14 }}>
                <p style={{ fontSize: 14, color: GRAY, margin: 0, lineHeight: 1.6 }}>
                  <span style={{ color: '#BF360C', fontWeight: 600 }}>Common mistake: </span>
                  {topic.mistake}
                </p>
              </div>
            </div>
          ))}

          {/* Bark replacement */}
          <div style={{ backgroundColor: DARK, borderRadius: 10, padding: '32px 28px', marginBottom: 24 }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: '#ffffff', marginBottom: 8, marginTop: 0 }}>
              How to Replace Orchid Bark
            </h2>
            <p style={{ fontSize: 15, color: '#b8cfc8', lineHeight: 1.8, marginBottom: 20, marginTop: 0 }}>
              Bark breaks down over 1–2 years and needs refreshing. Signs: bark crumbles easily, water drains slowly, or you smell something musty.
            </p>
            <ol style={{ paddingLeft: 24, margin: 0 }}>
              {BARK_STEPS.map((step, idx) => (
                <li key={idx} style={{ fontSize: 15, color: '#d0ede9', lineHeight: 1.9, marginBottom: 8 }}>
                  {step}
                </li>
              ))}
            </ol>
          </div>

          {/* Cross-link */}
          <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 10, padding: '24px 28px', marginBottom: 48, textAlign: 'center' }}>
            <p style={{ fontSize: 16, color: DARK, fontWeight: 600, marginBottom: 12, marginTop: 0 }}>
              Dealing with a specific problem?
            </p>
            <a href="/orchidproblems" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
              See the Orchid Troubleshooting Guide →
            </a>
          </div>

          <div style={{ textAlign: 'center', paddingBottom: 24 }}>
            <a href="/home" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
              ← Back to Orchima Home
            </a>
          </div>

        </div>
      </div>
    );
  }
}

OrchidEducation.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchidEducation));
